<script setup>
import { cleanNodeName } from '../../composables/formatUtils'
</script>

<template>
  <div class="kpi-tree">
    <div class="py-2 border-bottom border-dark" :class="!depth ? 'd-none' : ''">
      <div :style="indent">
        <div class="d-inline-block" role="button">
          <div v-if="node.nodes.length && depth > 1" @click="toggleNodes">
            <svg class="bi" width="16" height="16" fill="currentColor">
              <use v-if="showNodes" xlink:href="@/assets/icons/icons.svg#dash"/>
              <use v-else xlink:href="@/assets/icons/icons.svg#plus"/>
            </svg>
          </div>
          <div v-else-if="depth > 1" class="tree-node-collapse-placeholder"></div>
        </div>
        <div class="cont-icon-kpi d-inline-block me-1">
          <svg class="bi" width="16" height="16" fill="currentColor">
            <use v-if="node.folder" xlink:href="@/assets/icons/icons.svg#folder"/>
            <use v-else xlink:href="@/assets/icons/icons.svg#kpi"/>
          </svg>
        </div>
        <div class="d-inline-block tree-node-name">
          <span @click="selectKPI(node)" class="kpi-name" :class="selectedKPI.id === node.id ? 'fw-bold' : ''" role="button">{{ cleanNodeName(node.name) }}</span>
        </div>
      </div>
    </div>
    <div v-if="filteredNode && (showNodes || depth < 2)">
      <KPITree v-for="node in filteredNode.nodes" :key="node.id" :node="node" :depth="depth + 1" :mode="mode" :searchText="searchText" :autoOpenDepth="autoOpenDepth"></KPITree>
    </div>
  </div>
</template>

<script>

export default {
  name: 'KPITree',
  props: {
    node: Object,
    depth: Number,
    mode: String,
    searchText: String,
    autoOpenDepth: Number
  },
  data () {
    return {
      showNodes: this.depth < this.autoOpenDepth
    }
  },
  computed: {
    filteredNode () {
      return this.filterNode(this.node, this.searchText)
    },
    indent () {
      if (this.node.nodes && this.depth) {
        return { paddingLeft: `${(this.depth - 1) * 15}px` }
      } else {
        return { paddingLeft: `${this.depth * 15}px` }
      }
    },
    selectedKPI () {
      return this.$store.state.selectedKPI
    }
  },

  watch: {
    searchText: {
      handler (newValue) {
        const trimmed = newValue.trim()
        if (trimmed === '') {
          this.showNodes = this.depth < this.autoOpenDepth
        } else {
          this.showNodes = true
        }
      },
      immediate: true
    },
    autoOpenDepth () {
      this.showNodes = this.depth < this.autoOpenDepth
    }
  },

  methods: {
    filterNode (node, searchText) {
      const nodeMatches = cleanNodeName(node.name).toLowerCase().includes(searchText.trim().toLowerCase())

      let filteredChildren = []
      if (node.nodes && node.nodes.length > 0) {
        filteredChildren = node.nodes
          .map(child => this.filterNode(child, searchText))
          .filter(child => child !== null)
      }

      if (nodeMatches || filteredChildren.length > 0) {
        return {
          ...node,
          nodes: filteredChildren
        }
      }

      return null
    },
    async selectKPI (node) {
      this.$store.commit('SET_LOADING_STATUS', true)

      if (this.mode === 'cockpit' && node.folder) {
        this.toggleNodes()
      } else {
        await this.$store.dispatch('getKPI', { mode: this.mode, id: node.id }).then(() => {
          this.$parent.kpiModalElementId = node.id
          this.$parent.kpiKeyInt++
        })
      }

      this.$store.commit('SET_LOADING_STATUS', false)
      window.scrollTo(0, 0)
    },
    toggleNodes () {
      this.showNodes = !this.showNodes
    }
  }
}
</script>

<style lang="scss" scoped>
.kpi-tree {
  .cont-icon-kpi svg {
    margin-top: -3px;
  }
  .kpi-name:hover {
    font-weight: bold;
  }
}
</style>
